import Vue from "vue";
import Router from "vue-router";

///////////////////////////////////

//Main Routes
const CodeEntry = () => import("./routes/code-entry.vue");
const ContentViewer = () => import("./routes/content-viewer.vue");

///////////////////////////////////

//Use the router
Vue.use(Router);

///////////////////////////////////

var array = [];

//////////////////////////////////////

array.push({
  name: "code",
  path: "/",
  meta: {
    title: "Code Entry",
    requireUser: false,
  },
  component: CodeEntry,
});

///////////////////////////////////

array.push({
  name: "main.content.viewer",
  path: "/content/:code",
  meta: {
    title: "Content Viewer",
    requireUser: false,
  },
  component: ContentViewer,
});

///////////////////////////////////

var router = new Router({
  routes: array,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    //Keep track of where the user was scrolled
    //if they hit the back button
    var pos = 0;
    // Scroll to the top
    if (savedPosition) {
      pos = savedPosition.y;
    }
    document.body.scrollTop = document.documentElement.scrollTop = pos;
  },
});

///////////////////////////////////

router.beforeEach(async (to, from, next) => {
  //Close the drawer whenever we change route
  // store.commit('ui/drawer', false)

  if (!to || !to.name || !to.meta) {
    console.log("NO Route");
    return next("/");
  }

  if (to.meta) {
    await Vue.prototype.$hub.initialised();
    console.log("HAS ROUTE", to);
  }

  return next();
});

///////////////////////////////////

export default router;

///////////////////////////////////
